import PhotoCard from "./PhotoCard";

export default function MasonryFeed({ photos }) {
  return (
    <div
      className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 sm:gap-6"
      data-testid="masonry-feed"
    >
      {photos.map((p, i) => (
        <PhotoCard key={p.id} photo={p} index={i} />
      ))}
    </div>
  );
}
